import { z } from 'zod';

const NumericArraySchema = z.union([
  z.array(z.number()),
  z.instanceof(Float32Array).transform((value) => Array.from(value)),
]);

export const GateForceProfileSeriesSchema = z.object({
  angle: NumericArraySchema,
  force: NumericArraySchema,
});

export type GateForceProfileSeries = z.infer<typeof GateForceProfileSeriesSchema>;

const GateForceProfileContractInternalSchema = z.object({
  contract: z.literal('GateForceProfile'),
  version: z.literal('0.1.0'),
  sessionId: z.string(),
  series: z.record(GateForceProfileSeriesSchema),
  meta: z
    .object({
      targetPoints: z.number().int().positive().optional(),
      source: z.string().optional(),
    })
    .partial()
    .optional(),
});

export type GateForceProfileContract = z.infer<typeof GateForceProfileContractInternalSchema>;

type BuildGateForceContractArgs = {
  sessionId: string;
  series: unknown;
  meta?: GateForceProfileContract['meta'];
};

export const buildGateForceProfileContract = ({
  sessionId,
  series,
  meta,
}: BuildGateForceContractArgs): GateForceProfileContract => {
  const payload = {
    contract: 'GateForceProfile' as const,
    version: '0.1.0' as const,
    sessionId,
    series,
    meta,
  };

  return GateForceProfileContractInternalSchema.parse(payload);
};

export const validateGateForceProfileContract = (contract: unknown) =>
  GateForceProfileContractInternalSchema.parse(contract);
